import React, { useState, useEffect } from "react"
import styled from "styled-components";
import one from "../../../assets/fck.jpg";
import saveicon from "../../../assets/save.svg";
import { Link } from "react-router-dom";
import bookmark from '../../../assets/bookmark.png';
import { auth, db } from '../../../firebase';
import SignInDialog from "../Folios/SignInDialog";

const Tile = ({
    Image,
    Title,
    Name,
    Author,
    Rating,
    onclick,
    read,
    id,
    liked_By,
    setnavClick
}) => {
    const [save, setsave] = useState(false);
    const [pass, setpass] = useState(false);
    var saveId = [];
    let uid = '';
    if (localStorage.getItem('allowed') === '1' && auth.currentUser) {
        uid = auth.currentUser.uid;
        const userRef = db.collection('users').doc(uid);
        userRef.get().then(
            doc => {
                if (doc.data().saved.includes(id)) {
                    setsave(true);
                }
            }
        )
        // db.collection('users').doc(uid).get().then(
        //     doc => {
        //         if(doc.data().saved.includes(id)){
        //             setsave(true);
        //         }
        //         else{
        //             setsave(false);
        //         }
        //     }
        // )
    }
    const checkSignIn = () => {
        if (auth.currentUser === null) {
            setnavClick(true);
        }
    }
    const changeSaved = async (id) => {
        if (auth.currentUser === null) {
            checkSignIn();
        }
        else {
            const uid = JSON.parse(localStorage.getItem("user"))['uid'];
            // setpass(!pass);
            db.collection("users").doc(uid).get().then((doc) => {
                saveId = doc.data().saved;
                let arr = [...saveId];
                if (arr.indexOf(id) > -1) {

                    arr = arr.filter(e => e !== id);
                    setsave(false);

                    db.collection("users").doc(uid).update({ saved: arr });

                }
                else {

                    arr.push(id);

                    db.collection("users").doc(uid).update({ saved: arr });
                    setsave(true);
                }
            })
        }
    }

    return (
        <TileBox>
            <Box onClick={() => onclick(id)}>
                {/* Image */}
                <Img src={Image}></Img>

                <Typo>{Title}</Typo>
                {/* Author */}
                <Typox>{Name}</Typox>
                {/* Rating */}
            </Box>
            <Typox>{read} Reads
                <span onClick={() => changeSaved(id)}>
                    {save ? <BookImg src={bookmark} /> : <Icon src={saveicon} save={save} />}
                </span>
            </Typox>
        </TileBox>
    )

}

// =====================Styling components=============================

const TileBox = styled.div`
margin-bottom: 15px;
justify-content: center;
margin: 0 12px;
@media (max-width: 815px){
    margin: 0 8px;
};
@media (max-width: 450px){
    margin: 0 4px;
};
`
const Box = styled.div`
    // position: relative;
    /* border:2px solid red; */
    width: 149px;
    // margin-right: 2.92vw;
    // margin-right: 24px;
    margin-bottom: 0vh;
    &:hover{
        cursor: pointer;
    }
`
const Img = styled.img`
/* border:2px solid green; */
   
    width: 149px;
    height: 198px;
`
const Typo = styled.p`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size:14px;
    font-weight:600;
    font-family:Rubik;
    margin:1px;
    margin-top:10px;
    color:black;
`
const Typox = styled(Typo)`
    font-size:12px;
    font-weight:400;
    color:#A6A6A6;
    margin-bottom:3px;
    margin-top: 0vh;
    padding-bottom:3px;
`
const BookImg = styled.img`
    // height: 14.3px;
    width: 14px;
    float: right;
    // position: absolute;
    // margin-left: 6.45vw;
`

const Icon = styled.img.attrs(props => ({
}))`   
    // height: 14.3px;
    // width: 16.45px;
    float: right;   

    `;




export default Tile;